import { toast } from 'sonner';
import {
  useTaskQuickCapture,
  useUpdateTaskQuickCapture,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

export function TaskQuickCaptureSection() {
  const { data: enabled = false } = useTaskQuickCapture();
  const update = useUpdateTaskQuickCapture();

  function toggle(checked: boolean) {
    update.mutate(checked, {
      onError: (err) => {
        toast.error(
          err instanceof Error ? err.message : 'Impossible d’enregistrer la notation rapide',
        );
      },
    });
  }

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Notation rapide</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Saisie une ligne (étiquette, priorité, assigné, date) en liste, kanban et création
          rapide. La fiche de création reste complète, case cochée ou non.
        </p>
      </div>
      <label
        htmlFor="task-quick-capture"
        className={cn(
          'flex items-center gap-3 rounded-md border p-3 cursor-pointer',
          enabled ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200',
        )}
      >
        <input
          id="task-quick-capture"
          type="checkbox"
          className="h-4 w-4 accent-cime-primary"
          checked={enabled}
          disabled={update.isPending}
          onChange={(e) => toggle(e.target.checked)}
        />
        <span className="text-sm font-medium text-cime-text-primary">Activer</span>
      </label>
    </section>
  );
}
